import { render } from "./AddClient.vue?vue&type=template&id=1d30068e"
import script from "./AddClient.vue?vue&type=script&lang=js"
export * from "./AddClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__